function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M92.85,443.4h257.7c22.8,0,41.2-18.9,41.2-41.7V101.6c0-22.8-18.3-41.2-41.2-41.2h-41.9V41.1c0-5.5-4.5-9.7-10-9.7h-31.3 c-7.3-19-25.6-31.4-46.2-31.4c-20.5,0-38.4,12.4-46,31.4h-30.9c-5.5,0-10.5,4.2-10.5,9.7v19.3h-40.8c-23,0-41.3,18.4-41.3,41.2 v300.1C51.65,424.5,69.95,443.4,92.85,443.4z M153.65,51.4h28.7c4.6,0,8.7-3.3,9.7-7.8c3.3-14.2,15-23.8,29-23.8s26.2,10,29,23.5 c1,4.6,5,8.1,9.8,8.1h28.8v45h-135V51.4z M113.65,84.4h20v22.1c0,5.5,5,9.9,10.5,9.9h154.5c5.5,0,10-4.3,10-9.9V84.4h21v274h-216 V84.4z M71.65,101.6c0-11.8,9.3-21.2,21.2-21.2h0.8v288.4c0,5.5,4.1,9.6,9.6,9.6h236.7c5.5,0,9.6-4,9.6-9.6V80.4h0.8 c11.8,0,21.2,9.4,21.2,21.2v300.1c0,11.8-9.3,21.7-21.2,21.7H92.85c-11.8,0-21.2-9.9-21.2-21.7V101.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M300.25,180.4h-68.1c-5.5,0-10,4.5-10,10s4.5,10,10,10h68.1c5.5,0,10-4.5,10-10S305.75,180.4,300.25,180.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M193.65,156.4h-52c-5.5,0-10,4.5-10,10v47c0,5.5,4.5,10,10,10h52c5.5,0,10-4.5,10-10v-47 C203.65,160.9,199.15,156.4,193.65,156.4z M183.65,203.4h-32v-27h32V203.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M300.25,290.4h-68.1c-5.5,0-10,4.5-10,10s4.5,10,10,10h68.1c5.5,0,10-4.5,10-10S305.75,290.4,300.25,290.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M193.65,266.4h-52c-5.5,0-10,4.5-10,10v47c0,5.5,4.5,10,10,10h52c5.5,0,10-4.5,10-10v-47 C203.65,270.9,199.15,266.4,193.65,266.4z M183.65,313.4h-32v-27h32V313.4z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 443.4 443.4",
    style: {
      enableBackground: "new 0 0 443.4 443.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC75B"
    },
    d: "M381.95,101.6v300.1c0,17.4-14.1,31.4-31.4,31.4H92.85c-17.3,0-31.4-14-31.4-31.4V101.6 c0-17.4,14.1-31.4,31.4-31.4h48.2h3.1V74h-40.9v294.9h236.7V74h-41.3v-3.8h51.9C367.85,70.2,381.95,84.2,381.95,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC75B"
    },
    d: "M340.05,74v294.9h-236.8V74h40.9v32.6h154.5V74H340.05z M193.85,323.2v-46.5h-51.7v46.5H193.85z  M193.85,213.2v-46.5h-51.7v46.5H193.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED664C"
    },
    d: "M298.65,74v32.6h-154.5V74v-3.8V41.1h38.2c4.2-17.8,19.4-31.4,38.8-31.4s35.1,13.6,38.8,31.4h38.7 v29.1V74z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.05,
    y: 276.7,
    style: {
      fill: "#ED664C"
    },
    width: 51.7,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.05,
    y: 166.7,
    style: {
      fill: "#ED664C"
    },
    width: 51.7,
    height: 46.5
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.5498834a.svg";
export { ForwardRef as ReactComponent };